import { observer } from "mobx-react-lite";
import infoStyles from '../Info.module.css';

function PropertyInfo({ address, city, state, className, onClick }: IPropertyInfoProps) {
    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={onClick}>
            <div className={infoStyles.title}>{address}</div>
            <div className={infoStyles.description}>
                {city} {state}
            </div>
        </div>
    );
}

export interface IPropertyInfoProps {
    address: string;
    city: string;
    state: string;
    zip: string;
    className?: string;
    onClick?: () => void;
}

export default observer(PropertyInfo);